export const publickey = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQBnjskJx6Qr5MjE0APkNEYs
DGs0FihJrno/aDQwFzBANQCFcN20Y8gS3RqGY9wlyaGv3IxVIuIKTZyZBJGH/CPN
THv2WVfWaiIfjm6WperTqbRx1zoFxUA2G6y+ehRFK8kt9kpBN+f1R2s4pAqJbpVK
XylSWfz+WyG3hDx+t1JYI/K3+ovpwSCtNRUfeg9edLZ7Y0vX4kMeP3GE2SY5dHxO
g31kikOkHIl3pI0eJM+vCUb5KRXsYdJHlsE6KvSW8zr+0mQJGOEi9LOkKxVIGNZj
7tRhn4MCkTIlYf29zWGDlpzH3f9yH01iYF0YJpY3ds3bedkVgYfMP6H+CQi6WJQZ
AgMBAAE=
-----END PUBLIC KEY-----`